import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { ProductPresentation } from '../components/ProductPresentation';
import { ContentBreakdown } from '../components/ContentBreakdown';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForYouSection } from '../components/ForYouSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { BonusSection } from '../components/BonusSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { ImpactPhrases } from '../components/ImpactPhrases';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900" data-id="element-1145">
      <HeroSection data-id="element-1146" />
      <PainSection data-id="element-1147" />
      <TruthSection data-id="element-1148" />
      <ProductPresentation data-id="element-1149" />
      <ContentBreakdown data-id="element-1150" />
      <BenefitsSection data-id="element-1151" />
      <TestimonialsSection data-id="element-1152" />
      <ForYouSection data-id="element-1153" />
      <GuaranteeSection data-id="element-1154" />
      <BonusSection data-id="element-1155" />
      <ValueStack data-id="element-1156" />
      <FAQSection data-id="element-1157" />
      <ImpactPhrases data-id="element-1158" />
      <Footer data-id="element-1159" />
    </div>;
}